import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

const tabs = [
    {
        title: 'terminal.tabs.tab_01.title',
        text: 'terminal.tabs.tab_01.text',
    },
    {
        title: 'terminal.tabs.tab_02.title',
        text: 'terminal.tabs.tab_02.text',
    },
    {
        title: 'terminal.tabs.tab_03.title',
        text: 'terminal.tabs.tab_03.text',
    },
    {
        title: 'terminal.tabs.tab_04.title',
        text: 'terminal.tabs.tab_04.text',
    },
    {
        title: 'terminal.tabs.tab_05.title',
        text: 'terminal.tabs.tab_05.text',
    },
    {
        title: 'terminal.tabs.tab_06.title',
        text: 'terminal.tabs.tab_06.text',
    },
];

const Tabs = () => {
    const { t } = useTranslation();
    const [active, setActive] = useState(0);

    const setTab = value => active === value
        ? setActive(-1)
        : setActive(value);

    return (
        <section className="relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative flex flex-col lg:grid grid-cols-2 xl:gap-y-[60px] lg:gap-y-[40px] gap-x-[35px]">
                {tabs.map((tab, index) =>
                    <div
                        key={index}
                        onClick={() => setTab(index)}
                        className="flex flex-col lg:gap-[15px] border-b-[2px] border-b-[#15318D] py-[10px] lg:pt-0 lg:pb-[30px]"
                    >
                        <div className="flex gap-[15px] items-center justify-between">
                            <h4 className="font-[700] open-sans sm:text-[16px] text-[14px] text-[#0C2780]">
                                {t(tab.title)}
                            </h4>
                            <div className="lg:hidden w-[16px] h-[16px] relative flex-shrink-0">
                                <span className="absolute w-[100%] h-[2px] bg-[#0C2780] left-0 top-[50%] -translate-y-[50%]"></span>
                                <span className={`absolute w-[100%] h-[2px] bg-[#0C2780] left-0 top-[50%] -translate-y-[50%] ${index === active ? 'rotate-0' : 'rotate-90'} duration-200`}></span>
                            </div>
                        </div>
                        <p className={`${index === active ? 'flex' : 'hidden'} lg:w-full w-[90%] lg:flex font-[300] open-sans sm:text-[16px] text-[14px] text-[#0C2780] lg:mt-0 mt-[15px]`}>
                            {t(tab.text)}
                        </p>
                    </div>
                )}
            </div>
        </section>
    )
};

export default Tabs;
